export const buildApplicationUrl = (applicationId: string) => {
  return `${window.location.origin}/driver-application?applicationId=${applicationId}`
}
